var React = require('react');

function IconSparkle (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".6","fill":"#fff"},React.createElement("path",{"d":"M0 8.05l3.767-1.56A5.032 5.032 0 006.49 3.767L8.05 0l1.658 3.837a5.032 5.032 0 002.664 2.641l3.73 1.573-3.488 1.26a5.032 5.032 0 00-2.95 2.832l-1.613 3.959-1.521-3.89a5.032 5.032 0 00-3.003-2.91L0 8.052zM15.096 3.019l1.412-.585c.463-.192.83-.559 1.022-1.021L18.115 0l.621 1.439c.193.446.551.801 1 .99l1.398.59-1.308.473a1.887 1.887 0 00-1.106 1.062l-.605 1.484-.57-1.458c-.2-.51-.61-.908-1.127-1.091l-1.322-.47zM12.076 17.108l1.884-.78a2.516 2.516 0 001.361-1.362l.78-1.883.83 1.918a2.516 2.516 0 001.331 1.32l1.865.787-1.744.63a2.516 2.516 0 00-1.474 1.416l-.807 1.98-.76-1.945a2.516 2.516 0 00-1.502-1.455l-1.764-.626z"})));
}

IconSparkle.defaultProps = {"fill":"none","viewBox":"0 0 22 22"};

module.exports = IconSparkle;

IconSparkle.default = IconSparkle;
